import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { initializeApiClient } from '@/services/client/apiClient';

import './index.css'
import App from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// const appBaseUrl = import.meta.env.VITE_APP_API_URL + import.meta.env.VITE_API_PREFIX;
const appBaseUrl = import.meta.env.VITE_APP_API_URL;

try {
  initializeApiClient(appBaseUrl);
  console.log('API Client Initialized!');
} catch (error) {
  console.error("Failed to initialize API client:", error);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>
);
